<template>
  
    <content-header
        icona="fas fa-cog"
        titolo="Impostazioni"
    ></content-header>

    <div class="card sn-card-contenuto">
        <div class="card-header">
            <button type="button" class="btn btn-sm btn-warning" @click="disabled=false" v-if="disabled">
                <font-awesome-icon icon="fa-solid fa-lock-open"></font-awesome-icon>&nbsp;Sblocca configurazione
            </button>&nbsp;&nbsp;
            <button type="button" class="btn btn-sm btn-dark" @click="disabled=true" v-else>
                <font-awesome-icon icon="fa-solid fa-lock"></font-awesome-icon>&nbsp;Blocca configurazione
            </button>&nbsp;&nbsp;
            <button type="button" class="btn btn-sm btn-primary" :disabled="disabled" @click="SalvaConfig">
                <font-awesome-icon icon="fa-solid fa-floppy-disk"></font-awesome-icon>&nbsp;Salva
            </button>
        </div>
        <div class="card-body">
            <div class="alert alert-warning">ATTENZIONE! Modificare queste configurazioni solo se si è sicuri di quello che si sta facendo.</div>

            <messaggio-standard 
                    :mostraMessaggio="mostraMessaggio"
                    :alertClass="alertClass"
                    :alertIcon="alertIcon"
                    :alertIconSpin="alertIconSpin"
                    :alertMessaggio="alertMessaggio"
                    fontawesome="standard"
                    ></messaggio-standard>

            <div class="container">
            <form autocomplete="off">
                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <i class="fas fa-envelope text-primary"></i>&nbsp;Configurazioni per la posta elettronica (O365)
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label">O365 Tenant ID</label>
                    <input type="text" class="form-control" v-model="oConfig.o365MailTenantID" :disabled="disabled">
                </div>
                <div class="mb-3">
                    <label class="form-label">O365 Client ID</label>
                    <input type="text" class="form-control" v-model="oConfig.o365MailClientID" :disabled="disabled">
                </div>
                <div class="row">
                    <div class="col-md">
                        <label class="form-label">O365 Secret Value</label>
                        <input type="password" class="form-control" v-model="oConfig.o365MailSecretValue" :disabled="disabled">
                    </div>
                    <div class="col-md">
                        <label class="form-label">O365 Secret Value conferma</label>
                        <input type="password" class="form-control" v-model="oConfig.o365MailSecretValueConfirm" :disabled="disabled">
                    </div>
                </div>
                <div class="d-flex mb-3">
                    <small>Per cambiare il Secret inserire la stringa in entrambi i campi. Lasciare vuoto per non cambiare nulla. <b>NB Per motivi di sicurezza il secret attuale non viene mostrato.</b></small>
                </div>
                

                <div class="mb-3">
                    <label class="form-label">O365 Account per l'invio</label>
                    <input type="text" class="form-control" v-model="oConfig.o365MailAccountInvio" :disabled="disabled">
                </div>

                <div class="mb-3">
                    <button type="button" class="btn btn-primary" @click="MandaMailTest">Invia email di test</button>
                </div>

               

                <!-- <div class="row mb-3">
                    <div class="col-md">
                        <label class="form-label">Server SMTP</label>
                        <input type="text" class="form-control" v-model="oConfig.sendMailServer" :disabled="disabled">
                    </div>
                    <div class="col-md-2">
                        <label class="form-label">Porta</label>
                        <input type="text" class="form-control" v-model="oConfig.sendMailSMTPPort" :disabled="disabled">
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-3">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="oConfig.sendMailSSL" :disabled="disabled">
                            <label class="form-check-label" >
                                Usa SSL
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="oConfig.sendMailTLS" :disabled="disabled">
                            <label class="form-check-label" >
                                Usa STARTLS
                            </label>
                        </div>
                    </div>
                </div>
                
                
                <div class="mb-3">
                    <label class="form-label">Email del mittente</label>
                    <input type="text" class="form-control" v-model="oConfig.sendMailSender" :disabled="disabled">
                </div>

                
                <div class="mb-3">
                    <label class="form-label">Nome utente</label>
                    <input type="text" class="form-control" v-model="oConfig.sendMailUid" :disabled="disabled">
                </div>
                <div class="mb-3">
                    <label class="form-label">Password</label>
                    <input type="password" class="form-control" v-model="oConfig.sendMailPassword" :disabled="disabled">
                </div> -->


                <div class="row rigaSezioneForm mt-3">
                    <div class="col-md">
                        <i class="fas fa-bell text-warning"></i>&nbsp;Email notifica
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label">Destinatario email ciclo approvazione corsi</label>
                    <input type="text" class="form-control" v-model="oConfig.notifyCorsi" :disabled="disabled">
                </div>


                <div class="row rigaSezioneForm mt-3">
                    <div class="col-md">
                        <i class="fas fa-satellite-dish text-success"></i>&nbsp;Percorsi
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label">URL portale quiz utenti</label>
                    <input type="text" class="form-control" v-model="oConfig.pathQuiz" :disabled="disabled">
                </div>

               
                
                
            </form>
            </div>

           
        </div>
    </div>
    
</template>

<script>
//import GrigliaFacile from '@/components/GrigliaFacile.vue';
import snFunctions from '@/lib/snFunctions.js';
import ContentHeader from '@/components/layout/ContentHeader.vue';
import MessaggioStandard from '@/components/MessaggioStandard.vue';

export default {
    name: 'ImpostazioniView',
    components: {
        ContentHeader, MessaggioStandard
    },
    inject: ['cfg'],
    data: function() {
        return {
            disabled: true,

            oConfig: {
                "sendMailServer": "",
                "sendMailSMTPPort": 25,
                "sendMailSender": "",
                "sendMailSSL": false,
                "sendMailTLS": false,
                "sendMailPassword": "",
                "sendMailUid": "",

                "notifyCorsi": "",
                "pathQuiz": "",

                o365MailTenantID: "",
                o365MailClientID: "",
                o365MailSecretValue: "",
                o365MailAccountInvio: "",

                token: "",
                o365MailSecretValueConfirm: "",
            },

            mostraMessaggio: false,
            alertMessaggio: "",
            alertClass: "",     
            alertIcon: "",
            alertIconSpin: false,
        
        }
    },
    methods: {
        ClearMessaggio() {
            this.mostraMessaggio = false;
            this.alertMessaggio =  "";
            this.alertClass = "";
            this.alertIcon = "";
            this.alertIconSpin = false;
        },
        GetConfig() {
            fetch(this.cfg.apisrv + "/api/Config/GetConfig?token=" + this.$store.state.UserInfo.token)
            .then(response => response.json())
            .then(obj => {
                
                this.oConfig = obj;
                
            });
        },
        SalvaConfig(reload) {
            let oSubmit = [];
            oSubmit = this.oConfig;
            oSubmit.token = this.$store.state.UserInfo.token;

            this.ClearMessaggio();
            fetch(this.cfg.apisrv + "/api/Config/SalvaConfig", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Impostazioni salvate.'], 'alert alert-success', 'fa-check', false, 2000]});

                        this.GetConfig();
                    }
                    else {
                        this.$store.commit('Messaggio', {parms: [true, ['Errore salvataggio impostazioni.'], 'alert alert-danger', 'fa-times', false, 2000]});

                        this.mostraMessaggio = true;
                        this.alertMessaggio = obj.dati;
                        this.alertClass = "alert alert-warning";
                        this.alertIcon = "fa-xmark"
                        this.alertIconSpin = false
                    }
                });

      },

      MandaMailTest() {
        let dest = prompt("Specifica un destinatario");
        if(dest != "") {
            fetch(this.cfg.apisrv + "/api/Config/SendMailTest?token=" + this.$store.state.UserInfo.token + "&email=" + dest)
            .then(response => response.json())
            .then(obj => {
                
                if(obj.status == "OK") this.$store.commit('Messaggio', {parms: [true, ['Mail inviata.'], 'alert alert-success', 'fa-check', false, 2000]});
                if(obj.status == "KO") this.$store.commit('Messaggio', {parms: [true, ['Errore nell\'invio della mail.'], 'alert alert-danger', 'fa-times', false, 2000]});
                
                
            });
        }
      },
    
    
    },
    computed: {
        
    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");

        this.GetConfig();
     

    }
}
</script>